import React from 'react';
import Link from 'react-router/lib/Link';
import { withRouter } from 'react-router';
import Reactable from 'reactable';
import SimpleHeader from '../../../headers/simpleHeader';
import RoleAwareLink from '../../../../common/RoleAwareLink';
import Item from './ListItem';
import * as shapes from '../shapes';
import { mapTableHeaderColumns } from '../helpers';

const Table = Reactable.Table;
const Thead = Reactable.Thead;
const Th = Reactable.Th;
const List = ({ items, baseUrl, router }) => {
  const columns = mapTableHeaderColumns(items);

  return (
    <div className="c-wrapper">
      <SimpleHeader heading="Categories" />
      <div className="u-max-width-710 u-margin-auto u-mv-">
        <div className="o-flexbox">
          <RoleAwareLink to="/services" className="c-btn c-btn--medium u-width-120">
            Services
          </RoleAwareLink>
          <Link
            className="c-btn c-btn--medium"
            to={`${baseUrl}/add`}
          >
            Add category
          </Link>
        </div>
        <Table
          className="c-table-card c-table-new u-table-layout-fixed"
          display-if={items.length}
          sortable
          defaultSort={{ column: 'name', direction: 'asc' }}
        >
          <Thead className="c-table-card__head">
            {columns.map(column => (
              <Th
                className="c-table-card__cell c-label u-text-left"
                column={column}
                key={column}
              >
                {column}
              </Th>
            ))}
          </Thead>
          {items.map(item => Item({ item, baseUrl, router }))}
        </Table>
        <div className="c-heading c-heading--small u-mt" display-if={!items.length}>
          No categories are added. Click button to add new category.
        </div>
      </div>
    </div>
  );
};
List.propTypes = {
  items: shapes.categories,
  baseUrl: shapes.url,
  router: shapes.router.isRequired,
};
List.defaultProps = {
  items: [],
  baseUrl: '/services/categories',
};

export default withRouter(List);

